module.exports = __webpack_public_path__ + "static/media/image2.f2b9df9a.jpg";